import { useState } from "react";

export const useIndicatorControls = () => {
    const [showDataLabels, setShowDataLabels] = useState(false);
    const [showSubregions, setShowSubregions] = useState(false);
    const [useLogScale, setUseLogScale] = useState(false);

    const toggleDataLabels = () => {
        setShowDataLabels((prev) => !prev);
    };

    const toggleSubregions = () => {
        setShowSubregions((prev) => !prev);
    };

    const toggleLogScale = () => {
        setUseLogScale((prev) => !prev);
    };

    return {
        showDataLabels,
        showSubregions,
        useLogScale,
        toggleDataLabels,
        toggleSubregions,
        toggleLogScale
    };
};
